import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

interface ContextualMobileHeaderProps {
  title?: string;
}

const ContextualMobileHeader = ({ title }: ContextualMobileHeaderProps) => {
  return (
    <div className="pointer-events-none fixed left-3 top-[calc(0.75rem+env(safe-area-inset-top))] z-[1100] md:hidden">
      <Button
        variant="outline"
        size="icon"
        onClick={() => window.history.back()}
        className="pointer-events-auto h-11 w-11 rounded-full border-gray-200 bg-background/95 text-brand-midnight shadow-xl backdrop-blur supports-[backdrop-filter]:bg-background/80"
        aria-label={title ? `Back to ${title}` : 'Go back'}
      >
        <ArrowLeft className="h-5 w-5" />
      </Button>
    </div>
  );
};

export default ContextualMobileHeader;
